import React, { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import { debounce } from '../../../../../util/debounce';

export default (props) => {
  const {
    className,
    label,
    value,
    useDebounce,
    onChange,
    placeholder,
    type,
    maskChar,
    mask,
    disabled,
  } = props;

  const [stateValue, setStateValue] = useState('');

  // console.log('Input value: ', value)

  useEffect(() => {
    setStateValue(value);
  }, [value]);

  const onInputChanged = (value) => {
    setStateValue(value);
    if (useDebounce) {
      debounce(value, (v) => {
        checkOnChange(v);
      });
    } else {
      checkOnChange(value);
    }
  };

  const checkOnChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={['form-group', className].join(' ')}>
      <label hidden={!label}>{label || ''}</label>
      <InputMask
        maskChar={maskChar || ''}
        mask={mask || ''}
        disabled={disabled || ''}
        className="form-control"
        type={type || 'text'}
        onChange={(e) => onInputChanged(e.target.value)}
        value={stateValue}
        placeholder={placeholder || ''}
      />
    </div>
  );
};
